import { Model, OptionModel } from "services/models/model";
import { IModel } from "./../IModel";
import { ObjectMapper } from "json-object-mapper";

export class ICDClassificationModel
  extends Model
  implements IModel<ICDClassificationModel> {
  code: string = "";
  description: string = "";

  static create(input: any): ICDClassificationModel {
    return ObjectMapper.deserialize<ICDClassificationModel>(
      ICDClassificationModel,
      input
    );
  }

  toOption(): OptionModel {
    return {
      label: `${this["code"]} - ${this["description"]}`,
      value: this.id,
    } as OptionModel;
  }
}
